import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-objects-boss',
  slug: 'boss',
  title: 'Build a tiny EventEmitter',
  type: 'boss',
  estSeconds: 1200,
  contentVersion: 1,
});
